export const leadCandidatesStrings = {
  pageTitle: "Candidatos",
  addButton: "Agregar candidato",
  dialogTitle: "Nuevo candidato",
  detailTitle: "Detalle del candidato",
  editDetailTitle: "Editar candidato",
  searchLabel: "Buscar",
  searchPlaceholder: "Nombre, email, teléfono, estado…",
  dateFilterLabel: "Rango de fechas",
  excludeDateLabel: "Sin filtro de fecha",
  searchAction: "Buscar",
  cancel: "Cancelar",
  save: "Guardar",
  saving: "Guardando…",
  close: "Cerrar",
  emptyList: "No hay candidatos con los filtros seleccionados.",
  loadError: "No se pudo cargar la información.",
  saveError: "No se pudo guardar el candidato.",
  editNotAllowed: "Solo se pueden editar candidatos con origen import o manual en estado importado.",
  columns: {
    createdAt: "Creado",
    name: "Nombre",
    email: "Email",
    phone: "Teléfono",
    sourceType: "Origen",
    status: "Estado",
    promotedUserId: "Usuario promovido",
  },
  fields: {
    name: "Nombre",
    lastName: "Apellido",
    email: "Email",
    phone: "Teléfono",
    normalizedEmail: "Email normalizado",
    normalizedPhone: "Teléfono normalizado",
    sourceType: "Tipo de origen",
    sourceExternalId: "ID externo",
    sourceMeta: "Meta origen",
    status: "Estado",
    promotedUserId: "Usuario promovido",
    legacyUserId: "Usuario legacy",
    migrationBatchId: "Lote migración",
    migratedFromUser: "Migrado desde usuario",
    createdAt: "Creado",
    updatedAt: "Actualizado",
    id: "ID",
  },
} as const
